const rawEvents = [
  // New Year
  { categoryId: 'newyear', title: '신정', date: '2026-01-01', description: '병오년 (丙午年)의 해예요' },
  { categoryId: 'newyear', title: '신정', date: '2027-01-01', description: '정미년 (丁未年)의 해예요' },
  
  // Public Holidays
  { categoryId: 'holiday', title: '삼일절', date: '2026-03-01', description: '' },
  { categoryId: 'holiday', title: '대체공휴일', date: '2026-03-02', description: '' },
  { categoryId: 'holiday', title: '근로자의 날', date: '2026-05-01', description: '모든 근로자의 노고를 위로하기 위해 정한 날이에요' },
  { categoryId: 'holiday', title: '어린이날', date: '2026-05-05', description: '' },
  { categoryId: 'holiday', title: '부처님오신날', date: '2026-05-24', description: '' },
  { categoryId: 'holiday', title: '대체공휴일', date: '2026-05-25', description: '' },
  { categoryId: 'holiday', title: '전국동시지방선거', date: '2026-06-03', description: '' },
  { categoryId: 'holiday', title: '현충일', date: '2026-06-06', description: '' },
  { categoryId: 'holiday', title: '제헌절', date: '2026-07-17', description: '' },
  
  { categoryId: 'holiday', title: '광복절', date: '2026-08-15', description: '' },
  { categoryId: 'holiday', title: '대체공휴일', date: '2026-08-17', description: '' },
  { categoryId: 'holiday', title: '개천절', date: '2026-10-03', description: '' },
  { categoryId: 'holiday', title: '대체공휴일', date: '2026-10-05', description: '' },
  { categoryId: 'holiday', title: '한글날', date: '2026-10-09', description: '' },
  { categoryId: 'holiday', title: '크리스마스', date: '2026-12-25', description: '' },

  // 명절 (Holidays)
  { categoryId: 'holiday', title: '설날(시작)', date: '2026-02-16', description: '' },
  { categoryId: 'holiday', title: '설날(당일)', date: '2026-02-17', description: '' },
  { categoryId: 'holiday', title: '설날(끝)', date: '2026-02-18', description: '' },
  { categoryId: 'holiday', title: '추석(시작)', date: '2026-09-24', description: '' },
  { categoryId: 'holiday', title: '추석(당일)', date: '2026-09-25', description: '' },
  { categoryId: 'holiday', title: '추석(끝)', date: '2026-09-26', description: '' },

  { categoryId: 'holiday', title: '설날(시작)', date: '2027-02-06', description: '' },
  { categoryId: 'holiday', title: '설날(당일)', date: '2027-02-07', description: '' },
  { categoryId: 'holiday', title: '설날(끝)', date: '2027-02-08', description: '' },
  { categoryId: 'holiday', title: '대체공휴일', date: '2027-02-09', description: '' },

  // 2025 CSAT
  { categoryId: 'csat', title: '2026학년도 대학수학능력시험', date: '2025-11-13', target: '전체', host: '한국교육과정평가원' },
  // 2026 CSAT
  { categoryId: 'csat', title: '3월 모의고사', date: '2026-03-24', target: '고1·2·3' , host: '서울특별시 교육청' },
  { categoryId: 'csat', title: '5월 모의고사', date: '2026-05-07', target: '고3' , host: '경기도 교육청' },
  { categoryId: 'csat', title: '6월 모의고사 (평가원)', date: '2026-06-04', target: '고1·2·3' , host: '고1·2: 부산광역시 교육청, 고3: 한국교육과정평가원' },
  { categoryId: 'csat', title: '7월 모의고사', date: '2026-07-08', target: '고3' , host: '인천광역시 교육청' },
  { categoryId: 'csat', title: '9월 모의고사 (평가원)', date: '2026-09-02', target: '고1·2·3' , host: '고1·2: 인천광역시 교육청, 고3: 한국교육과정평가원' },
  { categoryId: 'csat', title: '10월 모의고사', date: '2026-10-20', target: '고1·2·3' , host: '고1·2: 경기도 교육청, 고3: 서울특별시 교육청' },
  { categoryId: 'csat', title: '2027학년도 대학수학능력시험', date: '2026-11-19', target: '전체', host: '한국교육과정평가원' },
  
  // 2027 CSAT
  { categoryId: 'csat', title: '2028학년도 대학수학능력시험', date: '2027-11-18', target: '전체', host: '한국교육과정평가원' }
];

// ID를 자동 부여하여 export
export const events = rawEvents.map((event, index) => ({
  ...event,
  id: index + 1
}));

export const categories = [
  { id: 'all', name: '전체 보기', icon: 'mdi-calendar-check', path: '/' },
  { id: 'csat', name: '수능/모의고사', icon: 'mdi-school', path: '/csat' },
  { id: 'newyear', name: '새해', icon: 'mdi-party-popper', path: '/newyear' },
  { id: 'holiday', name: '공휴일', icon: 'mdi-calendar-star', path: '/holiday' },
];